// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__yxWU5","select":"Header_select__2lMox","clinic":"Header_clinic__1Uq7J"};